export default class EvaluationTermDto {
  termId;
  termName;
  startDate;

  constructor(data) {
    this.termId = data.periodId;
    this.termName = data.periodName;
    this.startDate = data.startingDate;
  }
}
